import { createAcl, defineAclRules } from 'vue-simple-acl';
import { useAuthStore } from '@/stores/authStore';
import type { FeatureFlagType } from '@/types/FeatureFlagType';
import { FeatureKeyEnum } from '@/types/enums/FeatureKeyEnum';
import { computed } from 'vue';

export function createAclPlugin() {
    const authStore = useAuthStore();

    const getUserData = computed(() => {
        const user = authStore.user;
        const enabledFeatures = user?.enabled_features || [];

        return enabledFeatures;
    });

    const rules = () =>
        defineAclRules(setRule => {
            const possibleFeatures = Object.values(FeatureKeyEnum);

            for (const featureKey of possibleFeatures) {
                setRule(featureKey, (user: FeatureFlagType[]) => {
                    if (!Array.isArray(user)) {
                        return false;
                    }

                    return user.some((feature: FeatureFlagType) => {
                        return feature.key === featureKey && feature.enabled;
                    });
                });
            }
        });

    const simpleAcl = createAcl({
        user: getUserData,
        rules,
    });

    return simpleAcl;
}
